import { ConditionValueInputComponent } from 'Automations/nodeDefinitions/conditions'
import { ProductSelector } from './components/ProductSelector'

export const ProductValueInput: ConditionValueInputComponent = ({
  'data-testid': dataTestId,
  value,
  onChange,
  validationErrors
}) => (
  <ProductSelector
    multiple
    data-testid={dataTestId ? `${dataTestId}.value` : undefined}
    value={Array.isArray(value) ? value : []}
    onChange={next => onChange({ value: next })}
    validationErrors={validationErrors}
  />
)
